export { default } from './AccordionWrapper.component';
